import TABGROUP, { tabgroup } from '../../../DOM/GROUP/buttongroup/tabgroup/TABGROUP.js';
import NAV from '../../../DOM/nav/NAV.js';
import BUTTONGROUP, { buttongroup } from '../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import Switchable from '../../../../interface/Switchable.js';
// Model Structure
export const navBarAttr = makeAttrStruct([
    ['class'],
    ['name']
]);
export const navBarData = makeDataStruct([
    ['navLeft'],
    ['navCenter'],
    ['navRight']
]);
export const navBarModel = makeStruct([
    ['attributes', navBarAttr],
    ['data', navBarData]
]);
// Simplified model
export function navbar(className, name) {
    return {
        attributes: navBarAttr(className, name),
        data: navBarData()
    };
}
/** A full width collapseable NAV Element with 3 columns that contain buttons and tabs */
export default class NAVBAR extends NAV {
    navLeft;
    navCenter;
    navRight;
    constructor(node, model) {
        super(node, model);
        this.addClass('navbar flex-horizontal');
        this.implement(new Switchable(this));
        this.navLeft = new BUTTONGROUP(this, buttongroup('navLeft', 'flex-left vertical'));
        this.navCenter = new TABGROUP(this, tabgroup('navCenter', 'flex-center'));
        this.navRight = new BUTTONGROUP(this, buttongroup('navRight', 'flex-right'));
    }
}
